import { axios } from '@/utils/request'

// App management
export function getCallReportList (parameter = {}) {
  return axios({
    url: '/collectorCallCountReport/list',
    method: 'post',
    data: parameter
  })
}
